<template>
  <h1>Room {{ activeLeg.leg }}: {{ activePackage.content.DisplayName }}</h1>
  <div class="row mb-3" v-if="menus.length">
    <div class="col-24 d-flex justify-content-center">
      <ul class="menus row">
        <li class="col-24 col-xl" v-for="(restaurant, index) in menus">
          <a v-bind:href="restaurant.MenuLink" target="_blank"> Sample menu </a>
        </li>
      </ul>
    </div>
  </div>

  <div v-if="isLoading" class="position-relative d-flex justify-content-center">
    <loader></loader>
  </div>
  <div v-else>
    <div v-if="!showAvailability" class="row">
      <div class="col-24" v-for="(date, index) in dates" v-bind:key="index">
        <div class="date-panel p-4 mb-3" v-bind:class="{ on: date.checked }">
          <div class="row">
            <div class="mb-2 mb-xl-0 col-xl-8 d-flex">
              <div style="margin-right: 10px" v-if="dateIsAvailable(date.date)">
                <input type="checkbox" v-model="date.checked" />
              </div>

              <div v-on:click="date.checked = !date.checked">
                <span class="time-date-day">{{
                  formatDateLine1(date.date)
                }}</span>
                <span class="time-date-year">{{
                  formatDateLine2(date.date)
                }}</span>
              </div>
            </div>

            <div class="mb-2 mb-xl-0 col-xl-8">
              <div v-if="date.checked">
                <div class="d-flex flex-row">
                  <select
                    class="form-control form-select"
                    v-model="date.packageCount"
                    v-on:change="onChangeOccupancy($event, date)"
                  >
                    <option disabled selected value="">Guests</option>
                    <option
                      v-for="guestCount in guestCounts"
                      v-bind:key="guestCount"
                    >
                      {{ guestCount }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-xl-8">
              <div v-if="dateIsAvailable(date.date)">
                <div v-if="date.isLoaded">
                  <div
                    v-if="
                      date.availability &&
                      date.availability.Availability.TimeSlots.length
                    "
                  >
                    <div class="d-flex flex-row">
                      <select
                        class="form-control form-select"
                        v-model="date.selection"
                      >
                        <option disabled selected value="">
                          Select time...
                        </option>
                        <option
                          v-for="(ts, ti) in date.availability.Availability
                            .TimeSlots"
                          v-bind:value="ts.TimeSlot"
                          v-bind:key="ti"
                        >
                          {{ formatTime(ts.TimeSlot) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div v-else>
                    <span class="time-date-day">No availability</span>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="dinner-not-available">
                  This package is not available on this day.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-8">
    <div class="col-12 d-flex justify-content-start">
      <button
        class="btn btn--transparent btn--back"
        type="button"
        v-on:click="onClose()"
      >
        Close
      </button>
    </div>

    <div class="col-12 d-flex justify-content-end">
      <button
        class="btn btn--slate-blue btn--continue"
        type="button"
        v-on:click="onSubmit()"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import { store } from "../store/index";
import Loader from "@/shared/components/Loader.vue";

import restaurantapi from "@/shared/api/restaurant";
import stayapi from "@/shared/api/stay";

export default {
  name: "AccountPackageDinnerAvailability",
  props: {
    activeLeg: Object,
    activePackage: Object,
    activeBooking: Object,
  },
  components: {
    Loader,
  },
  computed: {
    guestCounts() {
      let result = [];
      let guests =
        this.activeLeg.GuestQuota.Adults + this.activeLeg.GuestQuota.Children;

      for (let i = 1; i <= guests; i++) {
        result.push(i);
      }

      return result;
    },
    restaurant() {
      return this.activePackage.content.Restaurant;
    },

    activeDates() {
      return this.dates.filter((item) => item.checked);
    },
    menus() {
      let menus = [];

      if (this.restaurant.MenuLink != null && this.restaurant.MenuLink.length) {
        menus.push({
          DisplayName: this.restaurant.DisplayName,
          MenuLink: this.restaurant.MenuLink,
        });
      }
      return menus;
    },
    booking() {
      return this.activeBooking;
    },
  },
  data() {
    return {
      isLoading: false,
      dates: [],
      showAvailability: false,
    };
  },
  mounted() {
    this.setDates();
  },
  methods: {
    onClose() {
      this.$parent.$emit("close");
    },
    onSubmit() {
      let items = [];
      let activeDates = this.activeDates.filter((item) => item.checked);
      for (let ai = 0; ai < activeDates.length; ai++) {
        let activeDate = activeDates[ai];
        items.push({
          timeSLot: activeDate.selection,
          restaurant: this.activePackage.content.Restaurant.RestaurantId,
        });
      }

      let quantity = +this.activeDates.filter((item) => item.checked).length;
      let payload = {
        internalIdentifier: this.activeLeg.InternalIdentifier,
        confirmationNumber: this.activeLeg.ConfirmationNumber,
        leg: this.activeLeg.Leg,
        productCode: this.activePackage.availability.Code,
        quantity: quantity,
        startDate: moment(this.activeLeg.DateRange.StartDate).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(this.activeLeg.DateRange.EndDate).format("YYYY-MM-DD"),
        items: items,
      };

      stayapi.addDiningPackage(payload, (t) => {
        window.location.reload();
      });

      this.onClose();
    },

    onChangeOccupancy: function (event, date) {
      this.isLoading = true;
      let payload = {
        Guests: date.packageCount,
        ArrivalDate: moment(date.date).format("YYYY-MM-DD"),
        NumberOfNights: 1,
        Restaurants: [this.activePackage.content.Restaurant.RestaurantId],
        Sitting: 2,
      };

      restaurantapi.getAvailability(payload, (t) => {
        date.isLoaded = true;

        date.availability = t[0].RestaurantAvailabilities[0];
        this.isLoading = false;
      });
    },

    setDates() {
      let result = [];

      var now = moment(this.activeLeg.DateRange.StartDate);
      var then = moment(this.activeLeg.DateRange.EndDate);
      var days = moment(moment.duration(now.diff(then))).get("days");
      for (let i = 0; i < days; i++) {
        let date = now.add(i, "d");
        if (!this.dateIsAvailable(date)) {
          continue;
        }

        result.push({ date, checked: false, packageCount: "" });
      }

      this.dates = result;
    },

    onShowAvailability() {
      this.showAvailability = true;
    },

    formatDateLine1(date) {
      return moment(date).format("dddd Do");
    },
    formatDateLine2(date) {
      return moment(date).format("MMMM YYYY");
    },
    formatTime(dateTime) {
      let date = moment(dateTime);
      return date.format("HH:mm");
    },
    dateIsAvailable(date) {
      var day = moment(date).day();
      var daysOpened = this.activePackage.content.Restaurant.DaysOpened;

      let result = false;
      switch (day) {
        case 0:
          result = daysOpened.Sunday;
          break;

        case 1:
          result = daysOpened.Monday;
          break;
        case 2:
          result = daysOpened.Tuesday;
          break;
        case 3:
          result = daysOpened.Wednesday;
          break;
        case 4:
          result = daysOpened.Thursday;
          break;
        case 5:
          result = daysOpened.Friday;
          break;
        case 6:
          result = daysOpened.Saturday;
          break;
        default:
          result = false;
          break;
      }
      return result;
    },
  },
};
</script>

<style scoped>
.time-date-day,
.time-date-year {
  display: block;
  width: 100%;
  font-size: 14px;
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
}

.time-date-day {
  font-weight: bold;
}

.time-date-year {
  font-weight: 400;
}

.date-panel {
  background: #fff;
}

.date-panel.on {
  background: #425260;
  color: #fff;
}

.date-panel input[type="checkbox"] {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.menus {
  display: flex;
  list-style: none;
  justify-content: center;
  height: 100%;
}

.menus li {
  align-items: center;
  display: flex;
  margin: 5px;
}

.menus li a {
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  font-family: Montserrat;
  text-decoration: underline;
  background-repeat: no-repeat;
  display: inline-block;
  padding-left: 30px;
  background-position: left center;
  background-size: 18px 25px;
  background-image: url("@/assets/img/booking/menu.svg");
}

.dinner-not-available {
  color: rgb(161, 0, 0);
  font-weight: bold;
}
</style>
